import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RegulatoryOffering from "@/pages/RegulatoryOffering";

export const Route = createFileRoute("/en/services/regulatory-affairs/regulatory-strategy-pharma")({
  head: () => buildRouteHead("/en/services/regulatory-affairs/regulatory-strategy-pharma"),
  component: RegulatoryOffering,
});

